import React from 'react';

/**
 * Overview Cards Component
 * Displays summary metrics in card format
 */
function OverviewCards({ metrics }) {
  const {
    totalValue,
    totalGainLoss,
    totalGainLossPercent,
    dailyChange,
    dailyChangePercent,
    holdingsCount,
    currency
  } = metrics;

  // Format currency value
  const formatCurrency = (value, decimals = 2) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
  };

  // Format percentage
  const formatPercent = (value, decimals = 2) => {
    return `${value >= 0 ? '+' : ''}${value.toFixed(decimals)}%`;
  };

  // Determine gain/loss color class
  const getColorClass = (value) => {
    if (value > 0) return 'positive';
    if (value < 0) return 'negative';
    return 'neutral';
  };

  return (
    <div className="overview-cards">
      {/* Total Portfolio Value Card */}
      <div className="overview-card">
        <div className="card-header">
          <span className="card-icon">💼</span>
          <h3 className="card-title">Total Value</h3>
        </div>
        <div className="card-body">
          <p className="card-value">{formatCurrency(totalValue)}</p>
          <p className="card-subtitle">Net Worth</p>
        </div>
      </div>

      {/* Total Gain/Loss Card */}
      <div className="overview-card">
        <div className="card-header">
          <span className="card-icon">📈</span>
          <h3 className="card-title">Total Gain/Loss</h3>
        </div>
        <div className="card-body">
          <p className={`card-value ${getColorClass(totalGainLoss)}`}>
            {formatCurrency(totalGainLoss)}
          </p>
          <p className={`card-subtitle ${getColorClass(totalGainLossPercent)}`}>
            {formatPercent(totalGainLossPercent)}
          </p>
        </div>
      </div>

      {/* Daily Change Card */}
      <div className="overview-card">
        <div className="card-header">
          <span className="card-icon">📊</span>
          <h3 className="card-title">Daily Change</h3>
        </div>
        <div className="card-body">
          <p className={`card-value ${getColorClass(dailyChange)}`}>
            {formatCurrency(dailyChange)}
          </p>
          <p className={`card-subtitle ${getColorClass(dailyChangePercent)}`}>
            {formatPercent(dailyChangePercent)}
          </p>
        </div>
      </div>

      {/* Holdings Count Card */}
      <div className="overview-card">
        <div className="card-header">
          <span className="card-icon">🏷️</span>
          <h3 className="card-title">Holdings</h3>
        </div>
        <div className="card-body">
          <p className="card-value">{holdingsCount}</p>
          <p className="card-subtitle">Active Positions</p>
        </div>
      </div>
    </div>
  );
}

export default OverviewCards;
